/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You"re encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it"ll be compiled.
//
// To reference this file, add <%= javascript_pack_tag "application" %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import "style/application.scss";
import "@popperjs/core"

import Bloodhound from "corejs-typeahead";
window.Bloodhound = Bloodhound;

import jQuery from "jquery";
window.$ = jQuery;
window.jQuery = jQuery;

import moment from "moment";
window.moment = moment;

import CodeMirror from "codemirror";
window.CodeMirror = CodeMirror;

import * as Popper from "@popperjs/core";
window.Popper = Popper;

window.bootstrap = require('bootstrap');
require('bootstrap-select/js/bootstrap-select');

import Chart from "chart.js/auto";
window.Chart = Chart;

import sanitizeHtml from "sanitize-html";
window.sanitizeHtml = sanitizeHtml;

window.DynamicModal = require('lib/dynamic_modal.js');

require('jquery-ujs')
require('daterangepicker')

// JQuery-UI
require('jquery-ui/ui/data')
require('jquery-ui/ui/effects/effect-highlight')
require('jquery-ui/ui/effect')
require('jquery-ui/ui/widget')
require('jquery-ui/ui/scroll-parent')
require('jquery-ui/ui/widgets/mouse')
require('jquery-ui/ui/widgets/sortable')

// custom
require('lib/confirm.js')
require('lib/daterangepicker_custom.js')
require('lib/jquery.textarea_autosize')
require('lib/bootstrap_custom.js')
require('lib/codemirror_custom/show_hint.js')
require('lib/codemirror_custom/twig.js')
require('lib/codemirror_custom/codemirror_custom.js')
require('lib/custom.js')
require('lib/report_updater.js')
require('lib/product_vat_categories.js')
require('lib/compiler.js')
require('lib/unhandled_rejection_listener.js')

// custom compilers
require('lib/compilers/ajax_modal_form.js')
require('lib/compilers/api_product_type_select.js')
require('lib/compilers/auto_import_setting.js')
require('lib/compilers/autofocus_on_load.js')
require('lib/compilers/check_api_auth.js')
require('lib/compilers/confirmation_modal.js')
require('lib/compilers/confirmation_modal_wizard.js')
require('lib/compilers/custom_shipping_date.js')
require('lib/compilers/default_shipping_combination_sku_list.js')
require('lib/compilers/delivery_tracking_package_selection.js')
require('lib/compilers/disable_button_on_submit.js')
require('lib/compilers/disabled_unless_filled.js')
require('lib/compilers/dynamic_modal.js')
require('lib/compilers/enabled_by_checked.js')
require('lib/compilers/filter_checkboxes_on_change.js')
require('lib/compilers/form_magento_shop_setting_switch_version.js')
require('lib/compilers/form_shopware_shop_setting_switch_shopware_version.js')
require('lib/compilers/form_submit_button.js')
require('lib/compilers/help_center_link.js')
require('lib/compilers/hide_shop_setup_instructions.js')
require('lib/compilers/tom_select_multi.js')
require('lib/compilers/mutual_exclusive_check_boxes.js')
require('lib/compilers/page_jump.js')
require('lib/compilers/preview_auto_import_start_date.js')
require('lib/compilers/preview_text.js')
require('lib/compilers/reprocess_shipping_labels_file.js')
require('lib/compilers/set_shipping_packaging_for_order.js')
require('lib/compilers/shop_setup_instructions.js')
require('lib/compilers/submit_on_change.js')
require('lib/compilers/submit_on_click.js')
require('lib/compilers/top_spacer.js')
require('lib/compilers/woocommerce_api_version.js')
require('lib/compilers/preview_label_button.js')
